import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferBatchDeleteQuery } from './type';

/**
 * c端个人中心offer管理 批量删除offer 数字商品/game service offer
  POST /product/offerManage/deleteOffer
  接口ID：263628558
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628558
 */
export const postOfferBatchDelete = (data: OfferBatchDeleteQuery[]): AxiosPromise => {
  return request({
    url: '/product/offerManage/deleteOffer',
    method: 'post',
    data
  });
};
